<template>
  <v-layout row justify-center>
    <v-dialog v-model="visible" persistent max-width="600px">
      <v-card class="mx-auto">
        <v-toolbar dark color="primary" height="45">
          <v-toolbar-title>Copy Dashboard</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn small icon color="primary" @click="close"><v-icon>close</v-icon></v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs6>
                <div class="v-input v-text-field v-select">
                  <label
                    aria-hidden="true"
                    class="v-label v-label--active theme--light"
                    style="left: 5px; right: auto; position: absolute; transform: translateY(-10px) scale(0.75); "
                    >Client</label
                  >
                  <kendo-dropdownlist
                    v-model="clientId"
                    :data-source="clientDataSource"
                    :data-text-field="'client'"
                    :data-value-field="'clientId'"
                    :filter="'contains'"
                  >
                  </kendo-dropdownlist>
                </div>
              </v-flex>
              <v-flex xs6>
                <div class="v-input v-text-field v-select">
                  <label
                    aria-hidden="true"
                    class="v-label v-label--active theme--light"
                    style="left: 5px; right: auto; position: absolute; transform: translateY(-10px) scale(0.75); "
                    >Dashboard</label
                  >
                  <kendo-dropdownlist
                    v-model="dashboardId"
                    :data-source="dashboardDataSource"
                    :data-text-field="'dashboard'"
                    :data-value-field="'dashboardId'"
                    @databound="onDashboardDropDownDataBound"
                    :filter="'contains'"
                  >
                  </kendo-dropdownlist>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue primary" @click="copy">Copy</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import axios from 'axios'
import {mapGetters} from 'vuex'
import confirmationWindow from '@/helpers/confirmation-window'
import notification from '@/helpers/notification'
export default {
  mounted() {},
  data() {
    return {
      clientId: 0,
      dashboardId: -1,
      visible: true,
    }
  },
  computed: {
    ...mapGetters({pageClientId: 'authentication/selectedClientId'}),
    clientDataSource() {
      return new kendo.data.DataSource({
        transport: {
          read: {
            url: '/api/report/dashboardPage/getClients',
            type: 'GET',
            data: {clientId: this.pageClientId},
          },
        },
      })
    },
    dashboardDataSource() {
      return new kendo.data.DataSource({
        transport: {
          read: {
            url: '/api/report/dashboardPage/getDashboards',
            type: 'GET',
            data: {clientId: this.clientId},
          },
        },
      })
    },
  },
  methods: {
    async copy() {
      const vm = this
      const item = {
        clientId: vm.pageClientId,
        dashboardId: vm.dashboardId,
        overwrite: false,
      }
      const copy = await axios.post('/api/report/dashboardPage/copyDashboards', item)
      if (copy.data.status == 1) {
        confirmationWindow.openConfirmationWindow('Copy Dashboards', copy.data.message, () => {
          axios.post('/api/report/dashboardPage/copyDashboards', item).then(function() {
            notification('dashboard copied', 'info')
            vm.$emit('copy')
          })
        })
      } else {
        notification(copy.data.message, 'info')
        vm.$emit('copy')
      }
    },
    close() {
      this.$emit('close')
    },
    onClose() {
      this.$emit('close')
    },
    onDashboardDropDownDataBound(e) {
      const [firstItem] = e.sender.dataSource.data()
      this.dashboardId = firstItem.dashboardId
    },
  },
}
</script>
